import React, { useState } from "react";
import { Card, Descriptions, PageHeader, Button } from "antd";
// import { ImageViewer } from "react-image-viewer-dv";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { ImageViewOnly } from "../image/onlyImageVIew";

export const ViewDrivingLicenceData = (props) => {
  const handleDownloadPDF = () => {
    const element = document.getElementById("view-profile");
    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("DrivingLicenceDetails.pdf");
    });
  };
  console.log("props", props);
   const [imageOpen, setImageOpen] = useState(false);
   const [selectedImage, setSelectedImage] = useState(null);

   const openImageModal = (img) => {
     setImageOpen(true);
     setSelectedImage(img);
   };

   const closeImageModal = () => {
     setImageOpen(false);
     setSelectedImage(null);
   };

  return (
    <div id="view-profile">
      <div style={{ padding: "20px 0" }}>
        <PageHeader
          onBack={false}
          title="Driving Licence Details"
          extra={[
            <Button type="primary" onClick={handleDownloadPDF}>
              Download PDF
            </Button>,
            <span style={{ display: "flex" }}>
              <Card
                className="viewCard"
                hoverable
                style={{
                  width: "100px",
                  height: "100px",
                  marginRight: 4,
                  borderRadius: "50%",
                  display: "flex",
                }}
                cover={
                  // <ImageViewer>
                  <img
                    className="image-viewer"
                    alt="example"
                    src={`data:image/png;base64,${props?.data?.profile_image}`}
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "50%",
                    }}
                    onClick={() =>
                      openImageModal(
                        `data:image/png;base64,${props?.data?.profile_image}`
                      )
                    }
                  />
                  // </ImageViewer>
                }
              />
            </span>,
          ]}
        >
          <Card className="viewCard">
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Licence Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.license_number
                    ? props?.data?.license_number
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Full Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.name ? props?.data?.name : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">DOB</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.dob
                    ? moment(props?.data?.dob).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Blood Group</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.blood_group
                    ? props?.data?.blood_group
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Citizenship</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.citizenship
                    ? props?.data?.citizenship
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Temporary Zip</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.temporary_zip
                    ? props?.data?.temporary_zip
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Current Status</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.current_status
                    ? props?.data?.current_status
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">DOE</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.doe
                    ? moment(props?.data?.doe).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">DOI</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.doi
                    ? moment(props?.data?.doi).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">Father or Husband Name</span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.father_or_husband_name
                    ? props?.data?.father_or_husband_name
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Gender</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.gender
                    ? props?.data?.gender == "F"
                      ? "Female"
                      : "Male"
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Has Image</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.has_image
                    ? props?.data?.has_image
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Initial doi</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.initial_doi
                    ? props?.data?.initial_doi
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Less Info</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.less_info
                    ? props?.data?.less_info
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Ola Code</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.ola_code
                    ? props?.data?.ola_code
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Ola Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.ola_name
                    ? props?.data?.ola_name
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Transport doe</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.transport_doe
                    ? props?.data?.transport_doe
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Transport doi</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.transport_doi
                    ? props?.data?.transport_doi
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Temporary Address</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.temporary_address
                    ? props?.data?.temporary_address
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Permanent Address</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.permanent_address
                    ? props?.data?.permanent_address
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">State</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.state ? props?.data?.state : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Vehicle Classes</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data &&
                  Array.isArray(props?.data?.vehicle_classes) &&
                  props?.data?.vehicle_classes
                    ? props?.data?.vehicle_classes.map((item) => (
                        <li>{item}</li>
                      ))
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Reason</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.type ? props?.data?.type : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Details</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.details
                    ? props?.data?.details
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </PageHeader>
        {imageOpen && (
          <ImageViewOnly
            imageOpen={imageOpen}
            imageUrl={selectedImage}
            onClose={closeImageModal}
          />
        )}
      </div>
    </div>
  );
};
